export default __webpack_public_path__ + "static/media/knol.03df3028.svg";